import React, { PropsWithChildren, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import Router from './Router';
import './index.scss';
import {
  NotificationFromDBProvider,
  NotificationProvider,
  UserProvider,
} from '@app/providers';
import { BrowserRouter } from 'react-router-dom';
import i18n from './i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

function Bootstrap(props: PropsWithChildren) {
  const { children } = props;

  useEffect(() => {
    // Prevent scroll restoration issues
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Cleanup function to reset scroll position on unmount
    return () => {
      window.scrollTo(0, 0);
    };
  }, []);

  if (!i18n.isInitialized) {
    return null;
  }

  return <>{children}</>;
}

root.render(
  <Bootstrap>
    <NotificationProvider>
      <NotificationFromDBProvider>
        <BrowserRouter>
          <UserProvider>
            <Router />
          </UserProvider>
        </BrowserRouter>
      </NotificationFromDBProvider>
    </NotificationProvider>
  </Bootstrap>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
